import React,{useState} from "react";
import { useParams } from "react-router-dom";
import { CAMPAIGN_ALL_LINK } from "../../../constants/constants";
import client from "../../../api";
import { notifyError, notifyErrorInBottom, notifySuccess } from "../../../helper";

const DeleteCampaignModelWindow = (props) => {
    const { setToogleDeleteModelWindow, toogleDeleteModelWindow } = props;
    const api = client();
    const {campaignID} = useParams('');
    const [loading, setLoading] = useState(false);
    const [confirmationText, setConfirmationText] = useState('');
    
    const handleInputField = (text) => {
        setConfirmationText(text);
    }

    const deleteCampaign = async () => {
        if(confirmationText.toLowerCase() !== 'delete'){
            notifyErrorInBottom('Please type "delete" to confirm this action.');
        } else {
            try{
                setLoading(true);
                const payload = {
                    campaigns_id: [campaignID],
                    status:"deleted"
                }
                
                const response = await api.post('/v1/campaign/status/update', payload);
                if(response.status === 200 || response.status === 201){
                    notifySuccess('Campaign deleted successfully');
                    setLoading(false);
                    setTimeout(()=>{
                        window.location.href = CAMPAIGN_ALL_LINK;
                    },1000);
                }                
            } catch(error){
                console.log('error.message',error);
                setLoading(false);
                if(error.status === 400) notifyError('Bad Request. Not able to delete Campaign');
            }
        }
    }
    
    return(<>
        <div className="model-window">
            <div className="overlay"></div>
            <div className="model-view">
                <div className="inner-view">
                    <h2>Are your sure to Delete Campaign?</h2>
                    <p>Are you certain you want to delete this campaign, along with its statistics and all related data? If you only wish to stop outbound emails, you can pause the campaign instead.</p>
                    <div className="form-fields">
                        <div className="field-wrap">
                            <label className="label-xs">Type the word delete</label>
                            <input 
                                type="text" 
                                name="campaign-name" 
                                onChange={(e)=>{
                                    handleInputField(e.target.value)}
                                }
                                value={confirmationText}
                                />
                        </div>
                    </div>
                    <div className="button-group">
                        <button 
                            type="button" 
                            className={loading ? "next-btn button--loading":"next-btn"} 
                            disabled={loading}
                            onClick={()=>deleteCampaign()}>
                                <span className="button--text">Delete</span>
                        </button>
                        
                        <button className="cancel-btn" onClick={()=>setToogleDeleteModelWindow(!toogleDeleteModelWindow)}>Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </>);
}

export default DeleteCampaignModelWindow;